import { ClaimSums } from "src/types/claim-sum";
import { DialogName } from "../workflow-dialogs/dialog-dictionary";

export const actionGroups = [
  'operation',
  'filing',
  'submission',
  'payment',
] as const;
export type ActionGroupId = (typeof actionGroups)[number];

export type CaseTableItemAction = {
  id: string;
  label: string;
  dialog: DialogName | null;
  frequency: number;
  is_close?: boolean;
  icon: string | null;
};

export type CaseTableItemActionGroup = {
  id: ActionGroupId;
  label: string;
  icon: string | null;
  items: CaseTableItemAction[];
};

export type CivilLawsuitContact = {
  label: string;
  dispute_is_full: boolean;
  filing_deadline_at: string;
  law_firm: {
    name: string;
    email: string | null;
    phone: string | null;
    address: string | null;
  };
};

export type CaseTableItem = {
  id: string;
  client_id: string;
  payee_case_reference_id: string;
  jurisdiction: string;
  started_at: string | null;
  product_type: string;
  coface_expired?: boolean;
  parties: {
    debtor_name: string | null;
    debtor_tax_number: string | null;
    debtor_address: string | null;
    client_name: string;
  };
  state: {
    stage: Stage;
    state_label_text_color: string;
    state_label_background_color: string;
    state_label: string;
    stage_label: string;
    action?: CaseTableItemAction | null;
  };
  partner: {
    integration: string;
    name: string;
    logo_url: string | null;
  } | null;
  displayed_claim: ClaimSums;
  hidden_claim: ClaimSums;
  actions: CaseTableItemActionGroup[];
  is_deletable: boolean;
  deleted_at?: string | null;
  is_editable: boolean;
  is_waiting_for_payment: boolean;
  awaiting_start_payment: boolean;
  can_pay_with_credit: boolean;
  has_been_submitted_to_notary?: boolean;
  bailiff_contact_url?: string | null;
  civil_lawsuit_contact?: CivilLawsuitContact | null;
  expected_transition: {
    label: string;
    at: string;
  } | null;
};

export type Pagination = {
  currentPage: number;
  lastPage: number;
  perPage: number;
  total: number;
};

export type GetCasesResponse = {
  data: CaseTableItem[];
  headers: never[];
  sortBy: never[];
  pagination: Pagination;
  counts?: Partial<Record<Stage, number>>;
};

export const stages = [
  'draft',
  'ongoing',
  'closed',
] as const;
export type Stage = typeof stages[number];

export const taskRecipients = [
  'ADMIN',
  'ATTORNEY',
] as const;
export type TaskRecipient = typeof taskRecipients[number];

export const products = [
  'notice',
  'demand_letter',
  'hard_1',
  'hard_2',
  'coface',
] as const;
export type Product = typeof products[number];

export type ClientOption = {
  uuid: string;
  name: string;
};

export const UNKNOWN_CLIENT_NAME = 'Unknown Client';

export type PartnerOption = {
  id: string;
  label: string;
};

export type DebtorOption = {
  name: string;
};
